import { getDialogHooks } from 'utilities/dialog-context/DialogContextHelpers';
import LearnMoreDialog, {
  LearnMoreDialogCallbackInput,
  LearnMoreDialogUniqueProps,
} from '../LearnMoreDialog';

const { useDialogForContext, useDialog: useLearnMoreDialog } = getDialogHooks<
  LearnMoreDialogUniqueProps,
  LearnMoreDialogCallbackInput
>(LearnMoreDialog);
export const useLearnMoreDialogForContext = useDialogForContext;
export default useLearnMoreDialog;
